import {
  ERROR_MESSAGE_FROM_SMARTY_SAVE,
} from './types';

export const saveErrorMessageFromPage = errorData => ({
  type: ERROR_MESSAGE_FROM_SMARTY_SAVE,
  payload: errorData,
});
